import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class AnalyticsApiManager extends BaseApiManager {
  private static instance: AnalyticsApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): AnalyticsApiManager {
    if (!AnalyticsApiManager.instance) {
      AnalyticsApiManager.instance = new AnalyticsApiManager();
    }
    return AnalyticsApiManager.instance;
  }

  public async getAverageWeeklySessions(userId: string | number, typeSession: string): Promise<ApiResponse<number>> {
    return this.request(`/core/utility/averageWeeklySessions/${userId}/${typeSession}`);
  }

  public async getCompletedSessions(userId: string | number): Promise<ApiResponse<number>> {
    return this.request(`/core/utility/CompletedSession/${userId}`);
  }

  public async markSessionCompleted(sessionId: string | number): Promise<ApiResponse<any>> {
    return this.request(`/core/utility/SessionsCompleted/${sessionId}`, {
      method: 'PUT'
    });
  }
}
